"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const mxw_libs_errors_1 = require("mxw-libs-errors");
const utils_1 = require("./utils");
function httpGet(url, params, overrides) {
    return new Promise((resolve, reject) => {
        let responseHandler = (error, response) => {
            if (error) {
                if (!error.response) {
                    return reject(mxw_libs_errors_1.errors.createError(mxw_libs_errors_1.errors.CONNECTION_ERROR, "Connection error", { url, error: error }));
                }
                response = error.response;
            }
            if (200 != response.status) {
                return reject(mxw_libs_errors_1.errors.createError(mxw_libs_errors_1.errors.INVALID_REQUEST, "Invalid response status " + response.status, { status: response.status, response }));
            }
            let result = response.data;
            if (result) {
                if (!utils_1.isUndefinedOrNullOrEmpty(result.ret)) {
                    if ("0" != result.ret && 0 != result.ret) {
                        let code = "" + result.ret;
                        let message = utils_1.isUndefinedOrNullOrEmpty(result.msg) ? "Failed response - " + code : result.msg;
                        return reject(mxw_libs_errors_1.errors.createError(code, message, { code, message, response: result }));
                    }
                }
                else if (!utils_1.isUndefinedOrNullOrEmpty(result.errcode)) {
                    if ("0" != result.errcode && 0 != result.errcode) {
                        let code = "" + result.errcode;
                        let message = utils_1.isUndefinedOrNullOrEmpty(result.errmsg) ? "Failed response - " + code : result.errmsg;
                        return reject(mxw_libs_errors_1.errors.createError(code, message, { code, message, response: result }));
                    }
                }
            }
            return resolve(result);
        };
        let config = overrides || {};
        if (utils_1.isUndefinedOrNullOrEmpty(config.timeout)) {
            config.timeout = 20000;
        }
        config["params"] = params;
        return axios_1.default.get(url, config).then((response) => {
            return responseHandler(undefined, response);
        }).catch(error => {
            return responseHandler(error, undefined);
        });
    });
}
exports.httpGet = httpGet;
function httpPost(url, data, overrides) {
    return new Promise((resolve, reject) => {
        let responseHandler = (error, response) => {
            if (error) {
                if (!error.response) {
                    return reject(mxw_libs_errors_1.errors.createError(mxw_libs_errors_1.errors.CONNECTION_ERROR, "Connection error", { url, error: error }));
                }
                response = error.response;
            }
            if (200 != response.status) {
                return reject(mxw_libs_errors_1.errors.createError(mxw_libs_errors_1.errors.INVALID_REQUEST, "Invalid response status " + response.status, { status: response.status, response }));
            }
            let result = response.data;
            if (result) {
                if (!utils_1.isUndefinedOrNullOrEmpty(result.ret)) {
                    if ("0" != result.ret && 0 != result.ret) {
                        let code = "" + result.ret;
                        let message = utils_1.isUndefinedOrNullOrEmpty(result.msg) ? "Failed response - " + code : result.msg;
                        return reject(mxw_libs_errors_1.errors.createError(code, message, { code, message, response: result }));
                    }
                }
                else if (!utils_1.isUndefinedOrNullOrEmpty(result.errcode)) {
                    if ("0" != result.errcode && 0 != result.errcode) {
                        let code = "" + result.errcode;
                        let message = utils_1.isUndefinedOrNullOrEmpty(result.errmsg) ? "Failed response - " + code : result.errmsg;
                        return reject(mxw_libs_errors_1.errors.createError(code, message, { code, message, response: result }));
                    }
                }
            }
            return resolve(result);
        };
        let config = overrides || {};
        if (utils_1.isUndefinedOrNullOrEmpty(config.timeout)) {
            config.timeout = 20000;
        }
        return axios_1.default.post(url, data, config).then((response) => {
            return responseHandler(undefined, response);
        }).catch(error => {
            return responseHandler(error, undefined);
        });
    });
}
exports.httpPost = httpPost;
//# sourceMappingURL=http.js.map